<!--Copyright (C) nexleader - All Rights Reserved-->
<!--Unauthorized copying of this file, via any medium is strictly prohibited-->
<!--Proprietary and confidential-->
<!--Written for nexleader <myipsat.com>, 2016-2026-->

<div id="nexleader-wrapper">
  <div class="content animate-panel">
    <!-- Loading State -->
    <div class="row" *ngIf="isLoading">
      <div class="col-md-12 text-center p-xl">
        <i class="fa fa-spinner fa-spin fa-3x"></i>
        <p class="m-t-md">Loading your IPSAT 2.0 Report...</p>
      </div>
    </div>

    <!-- No Report Found -->
    <div class="row" *ngIf="!isLoading && !archetypeReport">
      <div class="col-md-12">
        <div class="hpanel">
          <div class="panel-body text-center">
            <i class="fa fa-exclamation-circle fa-3x text-warning m-b-md"></i>
            <h4>No IPSAT 2.0 Report Found</h4>
            <p class="text-muted">This survey result doesn't have an archetype report yet.</p>
            <a [routerLink]="['/users', user?._id, 'surveyResults']" class="btn btn-default m-t-md">
              <i class="fa fa-arrow-left"></i>&nbsp;&nbsp;Back to Survey Results
            </a>
          </div>
        </div>
      </div>
    </div>

    <!-- Report Content -->
    <div class="row" *ngIf="!isLoading && archetypeReport">

      <!-- Regenerate banner (Steve 2026-06-11 item 2). Shown when the   -->
      <!-- current SurveyResult's 5 self-authored statements hash differs -->
      <!-- from the hash stored on the saved 2.0 report — i.e. the user  -->
      <!-- has edited their statements after the 2.0 was generated.      -->
      <div class="col-md-12" *ngIf="needsRegeneration">
        <div class="alert alert-warning">
          <div class="row">
            <div class="col-sm-9">
              <h5 class="font-bold m-t-none m-b-xs">
                <i class="fa fa-exclamation-triangle"></i>&nbsp;&nbsp;Your statements have changed
              </h5>
              <p class="m-b-none">
                You've updated your IPSAT 1.0 self-authored statements since this 2.0 report
                was generated. Regenerate to refresh the report with your latest answers —
                ask your coach for a regeneration code.
              </p>
            </div>
            <div class="col-sm-3 text-right">
              <button type="button" class="btn btn-success btn-lg m-t-sm" (click)="openRegenerateModal()">
                <i class="fa fa-refresh"></i>&nbsp;&nbsp;Regenerate
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Archetype Wheel + Overview -->
      <div class="col-md-12">
        <div class="hpanel">
          <div class="panel-heading">
            <div class="panel-tools">
              <a [routerLink]="['/users', user?._id, 'surveyResults', surveyResultId]"
                 class="m-r-md">
                <i class="fa fa-eye"></i>&nbsp;&nbsp;Original IPSAT
              </a>
              <a (click)="openShareModal()" class="m-r-md cursor-pointer">
                <i class="fa fa-share"></i>&nbsp;&nbsp;Share Result
              </a>
              <a [routerLink]="['/users', user?._id, 'surveyResults', surveyResultId, 'archetype', 'printable']">
                <i class="fa fa-print"></i>&nbsp;&nbsp;Print {{ user?.firstName }}'s Report
              </a>
            </div>
            <div class="clearfix"></div>
          </div>
          <div class="panel-body">
            <div class="row">
              <div class="col-sm-5">
                <h5 class="font-bold text-muted text-center m-b-md">Your Archetype is a lens, not a label.</h5>
                <app-archetype-wheel
                  [primary]="archetypeReport!.archetype.primary"
                  [secondary]="archetypeReport!.archetype.secondary || ''"
                ></app-archetype-wheel>
                <h5 class="font-bold text-muted text-center m-t-md">It brings clarity, not conformity.</h5>
              </div>
              <div class="col-sm-7">
                <h2 class="font-bold m-b-md text-primary-2">Your Archetype Overview</h2>
                <p class="m-b-md text-lg">
                  You are {{ startsWithVowel(archetypeReport!.archetype.primary) ? 'an' : 'a' }}
                  <strong>{{ archetypeReport!.archetype.primary }}</strong>&#8212;{{ getPrimaryDetails()?.report_overview }}
                </p>
                <p class="m-b-md text-lg" *ngIf="archetypeReport!.archetype.secondary">
                  Your <strong>{{ archetypeReport!.archetype.secondary }}</strong> overlay
                  adds additional dimensions.
                  {{ getOverlayDetails()?.report_overview }}
                </p>
                <p class="m-b-md text-lg" *ngIf="getPrimaryDetails()?.core_contribution">
                  <strong>Core contribution:</strong>
                  {{ getPrimaryDetails()?.core_contribution }}
                </p>
                <p class="m-b-md text-lg"
                   *ngIf="archetypeReport!.ipsatScore !== undefined && archetypeReport!.stage?.name">
                  <strong>Overall IPSAT Score:</strong> {{ archetypeReport!.ipsatScore }} / 100
                  &nbsp;·&nbsp;
                  <strong>Stage:</strong> {{ archetypeReport!.stage?.name }}
                </p>
              </div>
            </div>
          </div>
          <div class="panel-footer">
            <a class="btn btn-default" href="/assets/files/IPSAT_Faith_Coaching_Prep_Worksheet.pdf" target="_blank">
              <i class="fa fa-download"></i>&nbsp;&nbsp;Download IPSAT Coaching Prep Worksheet
            </a>
            <a class="btn btn-success pull-right" (click)="scrollToFramework()">
              Explore Archetypes
            </a>
            <div class="clearfix"></div>
          </div>
        </div>
      </div>

      <!-- Primary & Overlay Archetypes -->
      <div [class.col-md-6]="archetypeReport!.archetype.secondary" [class.col-md-12]="!archetypeReport!.archetype.secondary">
        <div class="hpanel hgreen">
          <div class="panel-heading">
            Primary Archetype
          </div>
          <div class="panel-body" style="min-height: 200px;">
            <h2 class="font-bold text-primary-2 m-b-sm">
              {{ archetypeReport!.archetype.primary }}
            </h2>
            <p class="text-muted m-b-md font-italic">{{ getPrimaryDetails()?.chapter_subtitle }}</p>
            <p>{{ getPrimaryDetails()?.report_overview }}</p>
          </div>
        </div>
      </div>

      <div class="col-md-6" *ngIf="archetypeReport?.archetype?.secondary">
        <div class="hpanel hblue">
          <div class="panel-heading">
            Overlay Archetype
          </div>
          <div class="panel-body" style="min-height: 200px;">
            <h2 class="font-bold text-info m-b-sm">
              {{ archetypeReport!.archetype.secondary }}
            </h2>
            <p class="text-muted m-b-md font-italic">{{ getOverlayDetails()?.chapter_subtitle }}</p>
            <p>
              Your {{ archetypeReport!.archetype.secondary }} overlay adds nuance to your
              primary pattern. {{ getOverlayDetails()?.report_overview }}
            </p>
          </div>
        </div>
      </div>

      <!-- Archetype Scores (coach/admin only). Per Steve 2026-06-08: the -->
      <!-- bar graph is hidden for participants because the numbers can be -->
      <!-- confusing on a first read. Coaches/admins still see it because -->
      <!-- the score distribution is useful for coaching conversations.   -->
      <!-- The Confidence label was removed entirely in the same email —  -->
      <!-- "very confusing even for coaches".                             -->
      <div class="col-md-12" *ngIf="canSeeBarGraph">
        <div class="hpanel">
          <div class="panel-heading">
            Your Archetype Scores
          </div>
          <div class="panel-body">
            <div class="row">
              <div class="col-md-6" *ngFor="let score of scoresArray">
                <div class="m-b-md">
                  <div class="flex flex-vertical-center m-b-xs">
                    <strong>{{ score.displayName }}</strong>
                  </div>
                  <div class="progress m-b-none">
                    <div
                      class="progress-bar"
                      [style.width]="getScorePercentage(score.score)"
                      [style.background-color]="score.archetype === primaryArchetypeKey ? 'var(--c-cat-personality)' : score.archetype === secondaryArchetypeKey ? 'var(--c-cat-gifts)' : 'var(--c-ink-faint)'"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Coach Note (verbatim copy from Steve 2026-06-08) -->
            <p class="m-t-md m-b-none text-muted text-base">
              <strong>Coach Note:</strong> The graph reflects archetype strength.
              The overlay reflects archetype influence. These are usually the same,
              but in close cases the engine may use identity-statement evidence to
              determine which secondary archetype most meaningfully shapes the
              primary pattern.
            </p>
          </div>
        </div>
      </div>

      <!-- Section Divider: Dashboard (per Steve's 2026-05-11 spec) -->
      <!-- 6 cards each with "Learn more" → archetype-specific modal. The old -->
      <!-- long-form sections (Strengths/Watch For/Ideal Projects/Stress & Recovery) -->
      <!-- were removed 2026-05-28 — the dashboard cards replace them. -->
      <div class="col-md-12">
        <h4 class="text-muted m-t-sm m-b-sm" style="border-bottom: 1px solid var(--c-rule-soft); padding-bottom: 10px;">
          <i class="fa fa-th-large"></i>&nbsp;&nbsp;Dive Deeper
        </h4>
      </div>

      <!-- CSS Grid keeps 2-up cards perfectly equal height regardless of -->
      <!-- per-row content length (Bootstrap 3 float grid doesn't equalize). -->
      <div class="col-md-12 m-b-lg">
        <div class="dashboard-card-grid">
          <app-archetype-dashboard-card
            *ngFor="let card of dashboardCards"
            [title]="card.title"
            [description]="card.description"
            ctaText="Learn more"
            (learnMore)="openCardModal(card.id)"
          ></app-archetype-dashboard-card>
        </div>
      </div>

      <!-- Print-report value callout (Steve 2026-06-11 90-Day email):     -->
      <!-- Users often miss that the printed report has additional         -->
      <!-- sections (Summary, Appendix). Flag it inline right under Dive   -->
      <!-- Deeper so the Print CTA up top isn't the only signal.           -->
      <!-- Counterintuitive Insights was the lead bullet until Steve       -->
      <!-- 2026-08-15 pulled that section from the printable report.       -->
      <div class="col-md-12 m-b-lg">
        <div class="hpanel" style="border-left: 4px solid var(--c-green);">
          <div class="panel-body">
            <div class="row">
              <div class="col-md-9">
                <h5 class="font-bold m-t-none m-b-xs text-success">
                  <i class="fa fa-file-pdf-o"></i>&nbsp;&nbsp;Want the full picture?
                </h5>
                <p class="m-b-xs">
                  The printable report goes deeper than this dashboard with sections you won't find here:
                </p>
                <ul class="m-b-none" style="padding-left: 20px;">
                  <li><strong>Summary</strong> — a closing synthesis of your archetype, contribution, and growth edge</li>
                  <li><strong>Original Identity Statements</strong> — your verbatim self-authored statements as an appendix</li>
                  <li>Plus the full archetype framework, stage of self-awareness, and a cover page suitable for sharing</li>
                </ul>
              </div>
              <div class="col-md-3 text-center" style="border-left: 1px solid var(--c-rule); padding-top: 20px;">
                <a class="btn btn-success btn-lg"
                   [routerLink]="['/users', user?._id, 'surveyResults', surveyResultId, 'archetype', 'printable']">
                  <i class="fa fa-print"></i>&nbsp;&nbsp;Print or Save as PDF
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Section Divider: The Framework -->
      <div class="col-md-12 archetype-framework-section">
        <h4 class="text-muted m-t-lg m-b-sm" style="border-bottom: 1px solid var(--c-rule-soft); padding-bottom: 10px;">
          <i class="fa fa-th-large"></i>&nbsp;&nbsp;The Archetype Framework
        </h4>
      </div>

      <!-- The Six Archetypes Overview -->
      <div class="col-md-12">
        <div class="hpanel">
          <div class="panel-heading">
            The Six IPSAT Archetypes
          </div>
          <div class="panel-body" style="background: var(--c-bg-tint);">
            <!-- CSS Grid → 3-up on desktop, equal height regardless of expand state -->
            <div class="six-archetypes-grid">
              <div class="hpanel six-archetypes-card"
                   [ngClass]="archetypeDetails[archetype].panelClass"
                   *ngFor="let archetype of ['visionary_strategist', 'bold_initiator', 'encouraging_connector', 'reflective_guide', 'steady_builder', 'curious_explorer']">
                <div class="panel-body">
                  <!-- Steve's designer PNG icon (matches the wheel), inline with the title -->
                  <div class="flex flex-vertical-center m-b-xs" style="gap: 12px;">
                    <app-archetype-icon
                      [archetype]="$any(archetype)"
                      [size]="40">
                    </app-archetype-icon>
                    <h5 class="font-bold" style="margin: 0;">{{ archetypeDisplayNames[archetype] }}</h5>
                    <div class="flex-grow"></div>
                    <span *ngIf="archetype === primaryArchetypeKey" class="label label-success">Your Primary</span>
                    <span *ngIf="archetype === secondaryArchetypeKey" class="label label-info">Your Overlay</span>
                  </div>
                  <p class="text-muted m-b-none text-base" style="line-height: 1.5;">
                    {{ archetypeDetails[archetype].tagline }}
                  </p>
                  <p class="m-t-sm m-b-none" *ngIf="expandedArchetypes.has(archetype)"
                     class="text-base" style="line-height: 1.6;">
                    {{ archetypeDetails[archetype].description }}
                  </p>
                </div>
                <div class="panel-footer">
                  <button type="button" class="btn btn-link btn-sm p-none"
                          style="text-decoration: none;"
                          (click)="toggleArchetypeDetail(archetype)">
                    <i class="fa" [class.fa-chevron-down]="!expandedArchetypes.has(archetype)"
                                  [class.fa-chevron-up]="expandedArchetypes.has(archetype)"></i>&nbsp;&nbsp;{{ expandedArchetypes.has(archetype) ? 'Show less' : 'Learn more' }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Spacer -->
      <div class="col-md-12 m-b-lg"></div>
    </div>

  </div>
</div>
